import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query standart sozlamalari — ilovaning "sezgi"sini belgilaydi,
 * shuning uchun bir joyda: har `useQuery` da qayta yozilsa, ba'zi sahifa
 * yangilanib, ba'zisi eskirib qoladi va sabab topilmaydi.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 30 soniya — ekranlar orasida sakraganda qayta so'ralmaydi, lekin
      // ma'lumot ham eskirib ketmaydi.
      staleTime: 30_000,
      // Fokus qaytganda avtomatik so'rov — abonent boshqa ilovadan qaytganda
      // butun ekran qayta yuklanardi; bu shovqin, foyda emas
      refetchOnWindowFocus: false,
      /*
        Ekran KO'RINMAYOTGANDA avtomatik yangilanish to'xtaydi.

        ⚠️ Bu TanStack Query standarti — o'zgartirish emas, KAFOLAT
        (`queryObserver`: `refetchIntervalInBackground || focusManager
        .isFocused()`, `isFocused` esa `document.visibilityState !== 'hidden'`).
        Aniq yozilgan sababi mobil: abonent brauzerni fonga tashlab
        qo'yganda `refetchInterval` batareyani ham, trafikni ham
        yemasligi kerak, va bu kafolat kod ichida ko'rinib tursin.
      */
      refetchIntervalInBackground: false,
      // 4xx ni qayta urinish ma'nosiz: huquq yo'q bo'lsa yana ham bo'lmaydi
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } }).response?.status
        if (typeof status === 'number' && status >= 400 && status < 500) return false
        return failureCount < 2
      },
    },
    mutations: {
      // Sotib olish TAKRORLANMAYDI: ikkinchi urinish ikkinchi paket degani
      // bo'lishi mumkin. Idempotency-Key baribir server tomonida ham
      // himoya qiladi (`shared/lib/idempotency.ts`), lekin bu ikkinchi qatlam.
      retry: false,
    },
  },
})
